/* PawVibe v4 Editorial: reveals, parallax, worlds, moments, index, hotspots, quick add, quick view, kit builder */
(function () {
  if (window.__pvx) return;
  window.__pvx = true;

  var C = window.PVX || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt;
  try {
    fmt = new Intl.NumberFormat(C.locale || undefined, { style: 'currency', currency: C.currency || 'GBP' });
  } catch (e) {
    fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: C.currency || 'GBP' });
  }
  function money(cents) { return fmt.format((Number(cents) || 0) / 100); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- Cart ---------- */
  function addItems(items) {
    return fetch(C.addUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Could not add to cart');
        return j;
      });
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('.cart-bubble__text-count, [data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        $$('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', cart.item_count === 0); });
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'pvx', data: { itemCount: cart.item_count, source: 'pvx' } }
          }));
        } catch (e) {}
        return cart;
      })
      .catch(function () {});
  }

  var toastTimer;
  function toast(title, text, img, isError) {
    var old = $('.pvx-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'pvx-toast';
    el.setAttribute('role', 'status');
    el.innerHTML =
      (img ? '<img alt="" width="56" height="56">' : '<span></span>') +
      '<div><strong></strong><span></span></div>' +
      (isError ? '' : '<div class="pvx-toast__actions"><a class="pvx-btn pvx-btn--line" href="' + (C.cartUrl || '/cart') + '">View cart</a><a class="pvx-btn pvx-btn--solid" href="/checkout">Checkout</a></div>') +
      '<button class="pvx-toast__close" type="button" aria-label="Close">&times;</button>';
    if (img) el.querySelector('img').src = img;
    el.querySelector('strong').textContent = title;
    el.querySelector('div span').textContent = text || '';
    el.querySelector('.pvx-toast__close').addEventListener('click', function () { el.remove(); });
    document.body.appendChild(el);
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); }); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-in'); setTimeout(function () { el.remove(); }, 500); }, 7000);
  }

  function busy(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.classList.toggle('is-loading', on);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pvx-add]');
    if (!btn) return;
    e.preventDefault();
    busy(btn, true);
    addItems([{ id: Number(btn.getAttribute('data-pvx-add')), quantity: 1 }])
      .then(function (res) {
        var item = res.items && res.items[0];
        busy(btn, false);
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1800);
        toast('Added to your cart', item ? item.product_title : btn.getAttribute('data-title'), item && item.image ? sized(item.image, 120) : '');
        refreshCart();
      })
      .catch(function (err) {
        busy(btn, false);
        toast('Sorry, that did not work', err.message, '', true);
      });
  });

  /* ---------- Quick view ---------- */
  var dlg;
  function openQuickView(handle, trigger) {
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'pvx pvx-qv';
      dlg.setAttribute('aria-label', 'Quick view');
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }
    if (trigger) busy(trigger, true);
    fetch((C.root && C.root !== '/' ? C.root : '') + '/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); })
      .then(function (p) {
        if (trigger) busy(trigger, false);
        renderQuickView(p);
        if (typeof dlg.showModal === 'function') dlg.showModal(); else window.location.href = p.url;
      })
      .catch(function () {
        if (trigger) busy(trigger, false);
        window.location.href = '/products/' + handle;
      });
  }

  function renderQuickView(p) {
    var imgs = (p.images || []).slice(0, 5);
    var variants = p.variants || [];
    var first = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var desc = document.createElement('div');
    desc.innerHTML = p.description || '';
    var text = (desc.textContent || '').replace(/\s+/g, ' ').trim();
    if (text.length > 320) text = text.slice(0, 317) + '...';

    dlg.innerHTML =
      '<button class="pvx-qv__close" type="button" aria-label="Close">&times;</button>' +
      '<div class="pvx-qv__in">' +
      '<div class="pvx-qv__media"><img alt="" data-qv-main><div class="pvx-qv__thumbs"></div></div>' +
      '<div class="pvx-qv__body">' +
      '<p class="pvx-kicker" data-qv-type></p>' +
      '<h2 class="pvx-qv__title"></h2>' +
      '<p class="pvx-qv__price" data-qv-price></p>' +
      '<p class="pvx-qv__desc"></p>' +
      '<div class="pvx-qv__opts"></div>' +
      '<div class="pvx-qv__row"><div class="pvx-qv__qty"><button type="button" data-q="-1" aria-label="Decrease quantity">−</button><input type="number" min="1" value="1" aria-label="Quantity"><button type="button" data-q="1" aria-label="Increase quantity">+</button></div>' +
      '<button class="pvx-btn pvx-btn--solid pvx-btn--lg" type="button" data-qv-add>Add to cart</button></div>' +
      '<p class="pvx-qv__note">Buy 2 save 10%, buy 3+ save 15%. Applied automatically in your cart.</p>' +
      '<a class="pvx-link" data-qv-link>See full details <span aria-hidden="true">→</span></a>' +
      '</div></div>';

    dlg.querySelector('[data-qv-type]').textContent = p.type || 'PawVibe';
    dlg.querySelector('.pvx-qv__title').textContent = p.title;
    dlg.querySelector('.pvx-qv__desc').textContent = text;
    dlg.querySelector('[data-qv-link]').href = p.url;
    var main = dlg.querySelector('[data-qv-main]');
    main.src = sized(imgs[0] || p.featured_image, 900);
    main.alt = p.title;
    var thumbs = dlg.querySelector('.pvx-qv__thumbs');
    if (imgs.length > 1) {
      imgs.forEach(function (src, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Image ' + (i + 1));
        if (i === 0) b.setAttribute('aria-current', 'true');
        b.innerHTML = '<img alt="">';
        b.querySelector('img').src = sized(src, 120);
        b.addEventListener('click', function () {
          main.src = sized(src, 900);
          $$('button', thumbs).forEach(function (x) { x.removeAttribute('aria-current'); });
          b.setAttribute('aria-current', 'true');
        });
        thumbs.appendChild(b);
      });
    }

    var opts = dlg.querySelector('.pvx-qv__opts');
    var hasOptions = !(variants.length === 1 && /default title/i.test(variants[0].title));
    var selects = [];
    if (hasOptions) {
      (p.options || []).forEach(function (opt, idx) {
        var name = typeof opt === 'string' ? opt : opt.name;
        var values = typeof opt === 'string' ? Array.from(new Set(variants.map(function (v) { return v.options[idx]; }))) : opt.values;
        var label = document.createElement('label');
        label.textContent = name;
        var sel = document.createElement('select');
        values.forEach(function (val) {
          var o = document.createElement('option');
          o.value = val; o.textContent = val;
          if (first && first.options[idx] === val) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', update);
        label.appendChild(sel);
        opts.appendChild(label);
        selects.push(sel);
      });
    }

    var addBtn = dlg.querySelector('[data-qv-add]');
    var current = first;
    function update() {
      if (selects.length) {
        var chosen = selects.map(function (s) { return s.value; });
        current = variants.filter(function (v) { return chosen.every(function (c, i) { return v.options[i] === c; }); })[0];
      }
      var priceEl = dlg.querySelector('[data-qv-price]');
      if (!current) {
        priceEl.textContent = '';
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }
      priceEl.textContent = money(current.price);
      if (current.compare_at_price > current.price) {
        var s = document.createElement('s');
        s.textContent = money(current.compare_at_price);
        priceEl.appendChild(s);
      }
      addBtn.disabled = !current.available;
      addBtn.textContent = current.available ? 'Add to cart · ' + money(current.price) : 'Sold out';
      if (current.featured_image && current.featured_image.src) main.src = sized(current.featured_image.src, 900);
    }
    update();

    var qty = dlg.querySelector('.pvx-qv__qty input');
    $$('[data-q]', dlg).forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.getAttribute('data-q')));
      });
    });
    addBtn.addEventListener('click', function () {
      if (!current) return;
      busy(addBtn, true);
      addItems([{ id: current.id, quantity: Math.max(1, parseInt(qty.value, 10) || 1) }])
        .then(function (res) {
          busy(addBtn, false);
          dlg.close();
          var item = res.items && res.items[0];
          toast('Added to your cart', p.title + (hasOptions ? ' · ' + current.title : ''), item && item.image ? sized(item.image, 120) : '');
          refreshCart();
        })
        .catch(function (err) { busy(addBtn, false); addBtn.textContent = err.message; });
    });
    dlg.querySelector('.pvx-qv__close').addEventListener('click', function () { dlg.close(); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pvx-qv]');
    if (!t) return;
    e.preventDefault();
    openQuickView(t.getAttribute('data-pvx-qv'), t);
  });

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var sel = [
      '.pvx-head > *', '.pvx-cover__copy > *', '.pvx-cover__lines li', '.pvx-dept', '.pvx-index__row',
      '.pvx-promise', '.pvx-edit__copy > *', '.pvx-scene__caption > *', '.pvx-manifesto__statement',
      '.pvx-manifesto__sign', '.pvx-kit__item', '.pvx-moments__clock', '.pvx-card', '.pvx-grid__head > *'
    ].join(',');
    var els = $$(sel).filter(function (el) { return !el.classList.contains('pvx-r'); });
    if (reduce || !('IntersectionObserver' in window)) return;
    var groups = new Map();
    els.forEach(function (el) {
      var p = el.parentElement;
      var i = groups.get(p) || 0;
      groups.set(p, i + 1);
      el.style.setProperty('--d', Math.min(i, 8));
      el.classList.add('pvx-r');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });

    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) en.target.classList.add('is-in'); });
    }, { threshold: 0.25 });
    $$('[data-pvx-scene]').forEach(function (el) { sio.observe(el); });
  }

  /* ---------- Parallax ---------- */
  function initParallax() {
    if (reduce) return;
    var els = $$('[data-pvx-parallax]');
    if (!els.length || initParallax.bound) return;
    initParallax.bound = true;
    var ticking = false;
    function run() {
      ticking = false;
      var vh = window.innerHeight;
      $$('[data-pvx-parallax]').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var speed = parseFloat(el.getAttribute('data-pvx-parallax')) || 0.05;
        var offset = (r.top + r.height / 2 - vh / 2) * speed;
        var target = el.querySelector('img') || el;
        target.style.setProperty('--pvx-y', (-offset).toFixed(1) + 'px');
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------- Worlds ---------- */
  function initWorlds() {
    $$('[data-pvx-worlds]').forEach(function (root) {
      if (root.__pvx) return; root.__pvx = true;
      var worlds = $$('.pvx-world', root);
      var tabs = $$('[data-world-tab]', root);
      function set(k) {
        worlds.forEach(function (w) { w.classList.toggle('is-active', w.getAttribute('data-world') === k); });
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-world-tab') === k ? 'true' : 'false'); });
      }
      var desktop = window.matchMedia('(min-width: 990px) and (hover: hover)');
      worlds.forEach(function (w) {
        w.addEventListener('mouseenter', function () { if (desktop.matches) set(w.getAttribute('data-world')); });
        w.addEventListener('focusin', function () { set(w.getAttribute('data-world')); });
      });
      tabs.forEach(function (t) { t.addEventListener('click', function () { set(t.getAttribute('data-world-tab')); }); });
    });
  }

  /* ---------- Moments tabs ---------- */
  function initTabs() {
    $$('[data-pvx-tabs]').forEach(function (root) {
      if (root.__pvx) return; root.__pvx = true;
      var tabs = $$('[role="tab"]', root);
      var panels = $$('[data-panel]', root);
      var cur = 0;
      function go(i, focus) {
        cur = (i + tabs.length) % tabs.length;
        tabs.forEach(function (t, j) {
          t.setAttribute('aria-selected', j === cur ? 'true' : 'false');
          t.tabIndex = j === cur ? 0 : -1;
        });
        panels.forEach(function (p, j) { p.classList.toggle('is-active', j === cur); });
        var t = tabs[cur];
        if (focus) t.focus();
        var bar = t.parentElement;
        if (bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: t.offsetLeft - 16, behavior: reduce ? 'auto' : 'smooth' });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { go(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1, true); }
        });
      });
      var panelsWrap = $('.pvx-moments__panels', root);
      var sx = null, sy = null;
      panelsWrap.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      panelsWrap.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) go(cur + (dx < 0 ? 1 : -1));
        sx = null;
      }, { passive: true });
    });
  }

  /* ---------- Index hover image ---------- */
  function initIndex() {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    $$('[data-pvx-index]').forEach(function (root) {
      if (root.__pvx) return; root.__pvx = true;
      var float = $('.pvx-index__float', root);
      var img = float && float.querySelector('img');
      if (!float) return;
      $$('.pvx-index__row', root).forEach(function (row) {
        row.addEventListener('mouseenter', function () {
          var src = row.getAttribute('data-img');
          if (!src) return;
          img.src = src;
          float.classList.add('is-on');
        });
        row.addEventListener('mouseleave', function () { float.classList.remove('is-on'); });
      });
      root.addEventListener('mousemove', function (e) {
        var r = root.getBoundingClientRect();
        float.style.setProperty('--fx', (e.clientX - r.left + 28) + 'px');
        float.style.setProperty('--fy', (e.clientY - r.top - 160) + 'px');
      });
    });
  }

  /* ---------- Hotspots ---------- */
  function initHotspots() {
    function closeAll(except) {
      $$('.pvx-hot.is-open').forEach(function (h) {
        if (h === except) return;
        h.classList.remove('is-open');
        h.querySelector('.pvx-hot__dot').setAttribute('aria-expanded', 'false');
      });
    }
    $$('[data-pvx-hot]').forEach(function (h) {
      if (h.__pvx) return; h.__pvx = true;
      var dot = h.querySelector('.pvx-hot__dot');
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        var small = window.matchMedia('(max-width: 749px)').matches;
        if (small) {
          var shop = h.closest('.pvx-scene').querySelector('.pvx-scene__chips');
          var idx = $$('[data-pvx-hot]', h.closest('.pvx-scene')).indexOf(h);
          var card = shop && shop.children[idx];
          if (card) {
            shop.scrollTo({ left: card.offsetLeft - 16, behavior: 'smooth' });
            card.animate && card.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.04)' }, { transform: 'scale(1)' }], { duration: 500 });
          }
          return;
        }
        var open = !h.classList.contains('is-open');
        closeAll(h);
        h.classList.toggle('is-open', open);
        dot.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    if (!initHotspots.bound) {
      initHotspots.bound = true;
      document.addEventListener('click', function (e) { if (!e.target.closest('.pvx-hot')) closeAll(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    }
  }

  /* ---------- Kit builder ---------- */
  function initKit() {
    $$('[data-pvx-kit]').forEach(function (root) {
      if (root.__pvx) return; root.__pvx = true;
      var t2 = Number(root.getAttribute('data-tier2')) || 0;
      var t3 = Number(root.getAttribute('data-tier3')) || 0;
      var picked = [];
      var els = {
        count: $('[data-kit-count]', root), noun: $('[data-kit-noun]', root), slots: $('[data-kit-slots]', root),
        empty: $('[data-kit-empty]', root), fill: $('[data-kit-fill]', root), hint: $('[data-kit-hint]', root),
        sub: $('[data-kit-subtotal]', root), save: $('[data-kit-save]', root), total: $('[data-kit-total]', root),
        add: $('[data-kit-add]', root)
      };

      function data(btn) {
        var li = btn.closest('.pvx-kit__item');
        var sel = li.querySelector('[data-kit-var]');
        var opt = sel && sel.options[sel.selectedIndex];
        return {
          btn: btn,
          id: Number(opt ? opt.value : btn.getAttribute('data-id')),
          price: Number(opt ? opt.getAttribute('data-price') : btn.getAttribute('data-price')),
          title: btn.getAttribute('data-title') + (opt ? ' · ' + opt.textContent : ''),
          img: btn.getAttribute('data-img')
        };
      }

      function render() {
        var n = picked.length;
        var sub = picked.reduce(function (a, p) { return a + p.price; }, 0);
        var pct = n >= 3 ? t3 : n === 2 ? t2 : 0;
        var save = Math.round(sub * pct / 100);
        els.count.textContent = n;
        els.noun.textContent = n === 1 ? 'piece' : 'pieces';
        els.sub.textContent = money(sub);
        els.save.textContent = save ? '−' + money(save) : money(0);
        els.total.textContent = money(sub - save);
        els.fill.style.width = (n === 0 ? 0 : n === 1 ? 25 : n === 2 ? 50 : 100) + '%';
        if (n === 0) els.hint.textContent = 'Add 2 pieces to save ' + t2 + '%.';
        else if (n === 1) els.hint.textContent = 'One more piece and you save ' + t2 + '%.';
        else if (n === 2) els.hint.textContent = 'Nice. Add a third piece to save ' + t3 + '%.';
        else els.hint.textContent = 'Kit complete. You save ' + t3 + '% (' + money(save) + ').';
        els.add.disabled = n === 0;
        els.add.textContent = n === 0 ? 'Add kit to cart' : 'Add kit to cart · ' + money(sub - save);
        els.empty.hidden = n > 0;
        els.slots.innerHTML = '';
        picked.forEach(function (p, i) {
          var li = document.createElement('li');
          li.innerHTML = '<img alt=""><button type="button" aria-label="Remove">×</button>';
          li.querySelector('img').src = p.img || '';
          li.querySelector('img').alt = p.title;
          li.querySelector('button').setAttribute('aria-label', 'Remove ' + p.title);
          li.querySelector('button').addEventListener('click', function () { toggle(p.btn, false); });
          els.slots.appendChild(li);
        });
      }

      function toggle(btn, force) {
        var i = picked.findIndex(function (p) { return p.btn === btn; });
        var on = typeof force === 'boolean' ? force : i === -1;
        if (on && i === -1) picked.push(data(btn));
        if (!on && i > -1) picked.splice(i, 1);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        render();
      }

      $$('.pvx-kit__toggle', root).forEach(function (btn) {
        btn.addEventListener('click', function () { toggle(btn); });
      });
      $$('[data-kit-var]', root).forEach(function (sel) {
        sel.addEventListener('change', function () {
          var li = sel.closest('.pvx-kit__item');
          var btn = li.querySelector('.pvx-kit__toggle');
          var opt = sel.options[sel.selectedIndex];
          li.querySelector('[data-kit-price]').textContent = opt.getAttribute('data-label');
          var i = picked.findIndex(function (p) { return p.btn === btn; });
          if (i > -1) { picked[i] = data(btn); render(); }
        });
      });
      $$('[data-kit-pet]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          var pet = b.getAttribute('data-kit-pet');
          $$('[data-kit-pet]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          $$('.pvx-kit__item', root).forEach(function (li) {
            var pets = (li.getAttribute('data-pets') || '').split(' ');
            li.hidden = pet !== 'all' && pets.indexOf(pet) === -1;
          });
        });
      });
      els.add.addEventListener('click', function () {
        if (!picked.length) return;
        busy(els.add, true);
        // Tag kit lines so the kit discount (Perfect Kit thread) can recognise them: _pv_kit = dog|cat-<10 chars>
        var petBtn = root.querySelector('[data-kit-pet][aria-pressed="true"]');
        var kitPet = petBtn && petBtn.getAttribute('data-kit-pet') === 'cat' ? 'cat' : 'dog';
        var kitId = kitPet + '-' + Math.random().toString(36).slice(2).padEnd(10, '0').slice(0, 10);
        addItems(picked.map(function (p) { return { id: p.id, quantity: 1, properties: { _pv_kit: kitId } }; }))
          .then(function () {
            busy(els.add, false);
            var n = picked.length;
            var img = picked[0].img;
            toast('Your kit is in the cart', n + (n === 1 ? ' piece' : ' pieces') + ' added. The kit saving is applied in your cart.', img);
            picked.slice().forEach(function (p) { toggle(p.btn, false); });
            refreshCart();
          })
          .catch(function (err) {
            busy(els.add, false);
            toast('Sorry, that did not work', err.message, '', true);
          });
      });
      render();
    });
  }

  function init() {
    initReveal();
    initParallax();
    initWorlds();
    initTabs();
    initIndex();
    initHotspots();
    initKit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
